/**
 * Mellona Conversion Optimization - Konsolide JS
 * ================================================
 * Tüm dönüşüm optimizasyonu özelliklerini tek bir dosyada toplar.
 *
 * Kapsam:
 *  1. Scroll takibi (sticky ATC için)
 *  2. Geri sayım mantığı
 *  3. Rastgele izleyici sayısı
 *  4. Çıkış niyeti tespiti
 *  5. Toast satın alma bildirimleri
 *  6. Dinamik teslimat tarihi hesaplama
 *
 * Kullanım: assets/mellona-conversion.js olarak yükleyin.
 * theme.liquid içinde </body> öncesine ekleyin:
 *   {{ 'mellona-conversion.js' | asset_url | script_tag }}
 */

(function (window, document) {
  'use strict';

  /* =========================================================
     YARDIMCI FONKSİYONLAR
  ========================================================= */

  /**
   * Cookie okuma
   */
  function getCookie(name) {
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i].split('=');
      if (decodeURIComponent(pair[0]) === name) {
        return decodeURIComponent(pair[1] || '');
      }
    }
    return null;
  }

  /**
   * Cookie yazma
   */
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
  }

  /**
   * Türk para formatı
   * @param {number} cents - Kuruş cinsinden tutar
   * @returns {string} "1.234,56 TL"
   */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' TL';
  }

  /**
   * Türkçe gün adları
   */
  var TR_DAYS = ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'];
  var TR_MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

  /**
   * Belirli iş günü sayısı kadar ilerletilmiş tarihi döndürür.
   * Hafta sonlarını (C.tesi ve Pazar) atlar.
   * @param {Date} fromDate - Başlangıç tarihi
   * @param {number} businessDays - Eklenecek iş günü sayısı
   * @returns {Date}
   */
  function addBusinessDays(fromDate, businessDays) {
    var date = new Date(fromDate.getTime());
    var daysAdded = 0;
    while (daysAdded < businessDays) {
      date.setDate(date.getDate() + 1);
      var dayOfWeek = date.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        daysAdded++;
      }
    }
    return date;
  }

  /**
   * Tarihi Türkçe formatla
   * @param {Date} date
   * @returns {string} "Pazartesi, 5 Ocak"
   */
  function formatDateTR(date) {
    return TR_DAYS[date.getDay()] + ', ' + date.getDate() + ' ' + TR_MONTHS[date.getMonth()];
  }


  /* =========================================================
     1. SCROLL TAKİBİ (Sticky ATC)
  ========================================================= */

  var MellonaScroll = {
    _ticking: false,
    _handlers: [],

    init: function () {
      var self = this;
      window.addEventListener('scroll', function () {
        if (!self._ticking) {
          window.requestAnimationFrame(function () {
            self._notifyHandlers();
            self._ticking = false;
          });
          self._ticking = true;
        }
      }, { passive: true });
    },

    onScroll: function (handler) {
      this._handlers.push(handler);
    },

    _notifyHandlers: function () {
      var scrollY = window.scrollY || window.pageYOffset;
      for (var i = 0; i < this._handlers.length; i++) {
        this._handlers[i](scrollY);
      }
    }
  };

  MellonaScroll.init();

  // Sticky ATC bar kontrolü
  function initStickyATC() {
    var stickyBar = document.getElementById('mellona-sticky-atc');
    var mainAtcBtn = document.querySelector('[data-add-to-cart], .product-form__submit, #AddToCart, [name="add"], .btn--add-to-cart');

    if (!stickyBar || !mainAtcBtn) return;

    MellonaScroll.onScroll(function () {
      var rect = mainAtcBtn.getBoundingClientRect();
      var shouldShow = rect.bottom < 0 || rect.top > window.innerHeight;
      stickyBar.classList.toggle('is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', String(!shouldShow));
    });
  }


  /* =========================================================
     2. GERİ SAYIM ZAMANLAYICISI
  ========================================================= */

  /**
   * Geri sayım başlatır.
   * @param {string} elementId - Timer metninin yazılacağı element ID
   * @param {number} durationHours - Sayaç süresi (saat)
   * @param {string} storageKey - sessionStorage anahtarı
   */
  function initCountdown(elementId, durationHours, storageKey) {
    var timerEl = document.getElementById(elementId);
    if (!timerEl) return;

    var now = Date.now();
    var endTime;
    var stored = sessionStorage.getItem(storageKey);

    if (stored && parseInt(stored, 10) > now) {
      endTime = parseInt(stored, 10);
    } else {
      endTime = now + durationHours * 60 * 60 * 1000;
      sessionStorage.setItem(storageKey, endTime.toString());
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var remaining = Math.max(0, endTime - Date.now());
      if (remaining === 0) {
        endTime = Date.now() + durationHours * 60 * 60 * 1000;
        sessionStorage.setItem(storageKey, endTime.toString());
        remaining = durationHours * 60 * 60 * 1000;
      }
      var totalSec = Math.floor(remaining / 1000);
      var h = Math.floor(totalSec / 3600);
      var m = Math.floor((totalSec % 3600) / 60);
      var s = totalSec % 60;
      timerEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    tick();
    return setInterval(tick, 1000);
  }

  // Sayfadaki tüm timer elementlerini bul ve başlat
  function initAllCountdowns() {
    document.querySelectorAll('[id^="mellona-timer-"]').forEach(function (el) {
      var sectionId = el.id.replace('mellona-timer-', '');
      var storageKey = 'mellona_countdown_end_' + sectionId;
      // Varsayılan 3 saat; section settings'ten gelmişse data attribute ile de alınabilir
      var hours = parseInt(el.getAttribute('data-hours') || '3', 10);
      initCountdown(el.id, hours, storageKey);
    });
  }


  /* =========================================================
     3. RASTGELE İZLEYİCİ SAYACI
  ========================================================= */

  function initViewerCount() {
    document.querySelectorAll('[id^="mellona-viewer-count-"]').forEach(function (el) {
      var current = Math.floor(Math.random() * 17) + 8; // 8-24
      el.textContent = current;

      setInterval(function () {
        var delta = Math.random() < 0.5 ? -1 : 1;
        current = Math.max(8, Math.min(24, current + delta));
        el.textContent = current;
      }, Math.floor(Math.random() * 7000) + 8000);
    });
  }


  /* =========================================================
     4. ÇIKIŞ NİYETİ TESPİTİ
  ========================================================= */

  var EXIT_COOKIE = 'mellona_exit_popup_shown';
  var EXIT_COOKIE_DAYS = 7;

  function initExitIntent() {
    var popup = document.getElementById('mellona-exit-popup');
    if (!popup) return;
    if (getCookie(EXIT_COOKIE)) return; // Zaten gösterildi

    var triggered = false;

    function showPopup() {
      if (triggered) return;
      triggered = true;
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setCookie(EXIT_COOKIE, '1', EXIT_COOKIE_DAYS);
      var firstInput = popup.querySelector('input, button');
      if (firstInput) {
        setTimeout(function () { firstInput.focus(); }, 350);
      }
    }

    // Masaüstü: fare üst sınırı geçince
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) showPopup();
    });

    // Mobil: 30 saniye sonra
    var isMobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
    if (isMobile) {
      setTimeout(showPopup, 30000);
    }

    // Kapat mekanizmaları
    var closeBtn = document.getElementById('mellona-ep-close');
    var backdrop = document.getElementById('mellona-ep-backdrop');
    var declineBtn = document.getElementById('mellona-ep-decline');

    function closePopup() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (backdrop) backdrop.addEventListener('click', closePopup);
    if (declineBtn) declineBtn.addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });
  }


  /* =========================================================
     5. TOAST SATIN ALMA BİLDİRİMLERİ
  ========================================================= */

  var TOAST_MESSAGES = [
  { name: 'Ayşe K.', city: 'Ankara', product: '1 adet Mini Pışpış Ürünü', time: 2 },
  { name: 'Fatma Ş.', city: 'İstanbul', product: '2 adet Mini Pışpış Ürünü', time: 5 },
  { name: 'Mehmet A.', city: 'İzmir', product: '1 adet Mini Pışpış Ürünü', time: 8 },
  { name: 'Zeynep T.', city: 'Bursa', product: '2 adet Mini Pışpış Ürünü', time: 3 },
  { name: 'Mustafa D.', city: 'Antalya', product: '2 adet Mini Pışpış Ürünü', time: 12 },
  { name: 'Emine Y.', city: 'Konya', product: '1 adet Mini Pışpış Ürünü', time: 1 },
  { name: 'Hüseyin K.', city: 'Adana', product: '2 adet Mini Pışpış Ürünü', time: 7 },
  { name: 'Selin Ö.', city: 'Gaziantep', product: '1 adet Mini Pışpış Ürünü', time: 4 },
  { name: 'Can B.', city: 'Kayseri', product: '2 adet Mini Pışpış Ürünü', time: 10 },
  { name: 'Merve C.', city: 'Eskişehir', product: '2 adet Mini Pışpış Ürünü', time: 6 }
];

  function createToastContainer() {
    var existing = document.getElementById('mellona-toast-container');
    if (existing) return existing;

    var container = document.createElement('div');
    container.id = 'mellona-toast-container';
    container.setAttribute('aria-live', 'polite');
    container.setAttribute('aria-label', 'Son satın alma bildirimleri');
    container.style.cssText = [
      'position: fixed',
      'bottom: 80px',
      'left: 20px',
      'z-index: 9998',
      'display: flex',
      'flex-direction: column',
      'gap: 10px',
      'pointer-events: none',
      'max-width: 300px'
    ].join(';');

    // CSS enjekte et
    if (!document.getElementById('mellona-toast-styles')) {
      var style = document.createElement('style');
      style.id = 'mellona-toast-styles';
      style.textContent = [
        '.mellona-toast {',
        '  background: #fff;',
        '  border-radius: 10px;',
        '  box-shadow: 0 4px 20px rgba(0,0,0,0.14);',
        '  padding: 12px 14px;',
        '  display: flex;',
        '  align-items: flex-start;',
        '  gap: 10px;',
        '  pointer-events: all;',
        '  border-left: 4px solid #B7A08C;',
        '  animation: mellona-toast-in 0.35s cubic-bezier(0.34,1.3,0.64,1) forwards;',
        '  will-change: transform, opacity;',
        '}',
        '.mellona-toast.is-leaving {',
        '  animation: mellona-toast-out 0.3s ease forwards;',
        '}',
        '@keyframes mellona-toast-in {',
        '  from { opacity: 0; transform: translateX(-20px) scale(0.95); }',
        '  to { opacity: 1; transform: translateX(0) scale(1); }',
        '}',
        '@keyframes mellona-toast-out {',
        '  from { opacity: 1; transform: translateX(0) scale(1); }',
        '  to { opacity: 0; transform: translateX(-20px) scale(0.95); }',
        '}',
        '.mellona-toast__icon {',
        '  flex-shrink: 0;',
        '  width: 36px;',
        '  height: 36px;',
        '  background: #fff3e0;',
        '  border-radius: 50%;',
        '  display: flex;',
        '  align-items: center;',
        '  justify-content: center;',
        '}',
        '.mellona-toast__body { flex: 1; min-width: 0; }',
        '.mellona-toast__title {',
        '  font-size: 12.5px;',
        '  font-weight: 700;',
        '  color: #1a1a1a;',
        '  margin: 0 0 2px;',
        '  white-space: nowrap;',
        '  overflow: hidden;',
        '  text-overflow: ellipsis;',
        '}',
        '.mellona-toast__meta {',
        '  font-size: 11.5px;',
        '  color: #888;',
        '  margin: 0;',
        '}',
        '.mellona-toast__time {',
        '  font-size: 11px;',
        '  color: #B7A08C;',
        '  margin: 3px 0 0;',
        '  font-weight: 600;',
        '}',
        '@media (max-width: 480px) {',
        '  #mellona-toast-container {',
        '    bottom: 75px;',
        '    left: 10px;',
        '    right: 10px;',
        '    max-width: none;',
        '  }',
        '}'
      ].join('\n');
      document.head.appendChild(style);
    }

    document.body.appendChild(container);
    return container;
  }

  function showToast(message) {
    var container = createToastContainer();

    var toast = document.createElement('div');
    toast.className = 'mellona-toast';
    toast.setAttribute('role', 'status');
    toast.innerHTML = [
      '<div class="mellona-toast__icon" aria-hidden="true">',
      '  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B7A08C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">',
      '    <circle cx="9" cy="21" r="1"></circle>',
      '    <circle cx="20" cy="21" r="1"></circle>',
      '    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
      '  </svg>',
      '</div>',
      '<div class="mellona-toast__body">',
      '  <p class="mellona-toast__title">' + message.name + ' — ' + message.city + '</p>',
      '  <p class="mellona-toast__meta">' + message.product + ' satın aldı</p>',
      '  <p class="mellona-toast__time">' + message.time + ' dakika önce</p>',
      '</div>'
    ].join('');

    container.appendChild(toast);

    // 4 saniye sonra kaldır
    setTimeout(function () {
      toast.classList.add('is-leaving');
      setTimeout(function () {
        if (toast.parentNode) toast.parentNode.removeChild(toast);
      }, 300);
    }, 4000);
  }

  function initPurchaseToasts() {
    // Toast bildirimleri göster (ürün sayfalarında)
    var isProductPage = document.body.classList.contains('template-product') ||
      document.querySelector('[data-page-type="product"]') !== null ||
      document.querySelector('.product-template, .product__title') !== null;

    if (!isProductPage) return;

    var messageQueue = TOAST_MESSAGES.slice();
    // Karıştır
    for (var i = messageQueue.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = messageQueue[i];
      messageQueue[i] = messageQueue[j];
      messageQueue[j] = temp;
    }

    var index = 0;
    var initialDelay = 5000 + Math.random() * 5000; // 5-10 saniye sonra başla

    setTimeout(function showNext() {
      if (index < messageQueue.length) {
        showToast(messageQueue[index]);
        index++;
        var nextDelay = 15000 + Math.random() * 20000; // 15-35 saniyede bir
        setTimeout(showNext, nextDelay);
      } else {
        // Döngüyü sıfırla
        index = 0;
        setTimeout(showNext, 30000);
      }
    }, initialDelay);
  }


  /* =========================================================
     6. DİNAMİK TESLİMAT TARİHİ
  ========================================================= */

  /**
   * Sayfa içindeki tüm teslimat tarihi elementlerini günceller.
   * Element'te data-delivery-days attribute'u varsa o kadar iş günü ekler,
   * yoksa varsayılan 2 iş günü eklenir.
   *
   * Kullanım (Liquid'de):
   *   <span class="mellona-delivery-date" data-delivery-days="2">hesaplanıyor...</span>
   */
  function initDeliveryDates() {
    var elements = document.querySelectorAll('.mellona-delivery-date, [data-delivery-date]');
    if (elements.length === 0) return;

    var today = new Date();
    // Saat 14:00'dan sonra giriş yapıldıysa +1 gün daha ekle (kesim saati)
    var cutoffHour = 14;
    var startDate = new Date(today);
    if (today.getHours() >= cutoffHour) {
      startDate.setDate(startDate.getDate() + 1);
    }

    elements.forEach(function (el) {
      var days = parseInt(el.getAttribute('data-delivery-days') || '2', 10);
      var deliveryDate = addBusinessDays(startDate, days);
      el.textContent = formatDateTR(deliveryDate);
    });
  }

  /**
   * Ürün sayfasında teslimat mesajı bloğu oluşturur.
   * Otomatik olarak .mellona-delivery-widget class'ına sahip elementlere enjekte edilir.
   */
  function initDeliveryWidget() {
    var widgets = document.querySelectorAll('.mellona-delivery-widget');
    if (widgets.length === 0) return;

    var today = new Date();
    var cutoffHour = 14;
    var startDate = new Date(today);
    if (today.getHours() >= cutoffHour) {
      startDate.setDate(startDate.getDate() + 1);
    }

    var deliveryDate = addBusinessDays(startDate, 2);
    var deliveryStr = formatDateTR(deliveryDate);

    var isBeforeCutoff = today.getHours() < cutoffHour;
    var cutoffMsg = isBeforeCutoff
      ? 'Bugün saat ' + cutoffHour + ':00\'a kadar sipariş verin'
      : 'Yarın sipariş verin';

    widgets.forEach(function (widget) {
      widget.innerHTML = [
        '<div style="display:flex;align-items:center;gap:8px;font-size:13.5px;color:#444;flex-wrap:wrap;">',
        '  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#FF8D0A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="1" y="3" width="15" height="13" rx="1"></rect><path d="M16 8h4l3 5v3h-7V8z"></path><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
        '  <span>' + cutoffMsg + ', <strong style="color:#FF8D0A;">' + deliveryStr + '</strong> teslim alın!</span>',
        '</div>'
      ].join('');
    });
  }


  /* =========================================================
     7. SEPETE EKLE GERİ BİLDİRİMİ (Global Event)
  ========================================================= */

  document.addEventListener('cart:updated', function (e) {
    // Tema'nın mini cart güncellemesini tetikle
    var fetchCartEvent = new CustomEvent('theme:cart:open');
    document.dispatchEvent(fetchCartEvent);

    // Sepet sayacını güncelle
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartCountEls = document.querySelectorAll('.cart-count, [data-cart-count], .cart__item-count, .header__cart-count');
        cartCountEls.forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.classList.remove('is-hidden', 'hidden');
        });
      })
      .catch(function () {});
  });


  /* =========================================================
     SAYFA YÜKLENDİĞİNDE TÜM MODÜLLERİ BAŞLAT
  ========================================================= */

  function init() {
    initStickyATC();
    initAllCountdowns();
    initViewerCount();
    initExitIntent();
    initPurchaseToasts();
    initDeliveryDates();
    initDeliveryWidget();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Public API (tema diğer dosyalarından çağırabilir) */
  window.Mellona = window.Mellona || {};
  window.Mellona.formatMoney = formatMoney;
  window.Mellona.addBusinessDays = addBusinessDays;
  window.Mellona.formatDateTR = formatDateTR;
  window.Mellona.showToast = showToast;
  window.Mellona.initCountdown = initCountdown;
  window.Mellona.getCookie = getCookie;
  window.Mellona.setCookie = setCookie;

}(window, document));
